import { useEffect, useRef } from "react"

export const filterValues = (type, formValues, options) => {
  const usedRecords = Object.entries(formValues)
    .filter(([k]) => k.startsWith(type))
    .map(([_, v]) => v)

  return options.filter((o) => !usedRecords.includes(o.title))
}
